import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
	Redirect,
	Switch,
	Route,
	useParams,
	useLocation,
	useHistory,
} from 'react-router-dom';
import { useGetContainerWidth, useCreateDispatches } from 'helpers/hooks';
import { useMobileListCheck } from 'helpers';
import { CalendarActivity, Welcome } from 'components';
import ViewCalendar from './components/ViewCalendar';
import CalendarListContainer from './components/CalendarListContainer';
import styles from './calendar.module.css';

const Calendar = (props) => {
	const {
		fullScreen,
		basePath = '/calendar',
		activityBasePath = '/calendarActivity',
		trustedCaseManagerRoute = false,
	} = props;
	const { user } = useSelector(({ user }) => user);
	const scopedChild = useSelector((state) => state.lifebooks.child);
	const params = useParams();
	const { childId, feedType } = params;
	const { pathname } = useLocation();
	const mediaQuery = useSelector((state) => state.mediaQuery);
	const { push } = useHistory();

	useMobileListCheck(
		!trustedCaseManagerRoute && pathname === `${basePath}/`,
	);
	const { setRoot } = useCreateDispatches();

	const { ref: rightContentRef } = useGetContainerWidth();

	useEffect(() => {
		if (user.type === 'child') {
			push(`${basePath}/${user.id}`);
		}
	}, [basePath, push, user.id, user.type]);

	useEffect(() => {
		setRoot('calendar');
	}, [setRoot]);

	if (trustedCaseManagerRoute && !scopedChild.id) return null;

	if (trustedCaseManagerRoute) {
		const activityRoute =
			pathname === activityBasePath ||
			pathname.startsWith(`${activityBasePath}/`);
		const requestedBasePath = activityRoute ? activityBasePath : basePath;
		const requestedChildId = pathname
			.slice(requestedBasePath.length)
			.split('/')
			.filter(Boolean)[0];
		if (!requestedChildId || requestedChildId !== scopedChild.id) {
			return <Redirect to={`${requestedBasePath}/${scopedChild.id}`} />;
		}
	}

	return (
		<div
			className={styles.calendarContainer}
			style={mediaQuery.mobile ? { height: mediaQuery.height } : {}}>
			{user.type !== 'child' && !trustedCaseManagerRoute ? (
				<CalendarListContainer />
			) : null}
			<div
				ref={rightContentRef}
				className={[
					styles.calendarRightContent,
					fullScreen && styles.calendarRightFull,
				].join(' ')}
				style={mediaQuery.mobile ? { height: mediaQuery.height } : {}}>
				<div className={styles.calendarContent}>
					<Switch>
						<Route
							key={childId + feedType}
							path={`${activityBasePath}/:childId/`}>
							<CalendarActivity returnBase={basePath} />
						</Route>
						<Route key={childId} path={`${basePath}/:childId`}>
							<ViewCalendar />
						</Route>
						<Route path='/'>
							<Welcome user={user} />
						</Route>
					</Switch>
				</div>
			</div>
		</div>
	);
};

export default Calendar;
